var map = {
	"./dataspace/dataspace.module": [
		"./src/app/dataspace/dataspace.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"common",
		"dataspace-dataspace-module"
	],
	"./logo/logo.module": [
		"./src/app/logo/logo.module.ts",
		"logo-logo-module"
	],
	"./network-admin/network-admin.module": [
		"./src/app/network-admin/network-admin.module.ts",
		"network-admin-network-admin-module"
	],
	"./networkHealthCheck/networkHealthCheck.module": [
		"./src/app/networkHealthCheck/networkHealthCheck.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"default~networkHealthCheck-networkHealthCheck-module~scheduler-scheduler-module",
		"common",
		"networkHealthCheck-networkHealthCheck-module"
	],
	"./participants/participants.module": [
		"./src/app/participants/participants.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"default~participants-participants-module~reports-reports-module~revoke-revoke-module~trustedlist-tru~86618b40",
		"common",
		"participants-participants-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"default~participants-participants-module~reports-reports-module~revoke-revoke-module~trustedlist-tru~86618b40",
		"default~reports-reports-module~revoke-revoke-module",
		"common",
		"reports-reports-module"
	],
	"./revoke/revoke.module": [
		"./src/app/revoke/revoke.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"default~participants-participants-module~reports-reports-module~revoke-revoke-module~trustedlist-tru~86618b40",
		"default~reports-reports-module~revoke-revoke-module",
		"common",
		"revoke-revoke-module"
	],
	"./scheduler/scheduler.module": [
		"./src/app/scheduler/scheduler.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"default~networkHealthCheck-networkHealthCheck-module~scheduler-scheduler-module",
		"common",
		"scheduler-scheduler-module"
	],
	"./transfer/transfer.module": [
		"./src/app/transfer/transfer.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"common",
		"transfer-transfer-module"
	],
	"./trustedlist/trustedlist.module": [
		"./src/app/trustedlist/trustedlist.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"default~participants-participants-module~reports-reports-module~revoke-revoke-module~trustedlist-tru~86618b40",
		"common",
		"trustedlist-trustedlist-module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"default~dataspace-dataspace-module~networkHealthCheck-networkHealthCheck-module~participants-partici~c9d233bd",
		"common",
		"users-users-module"
	],
	"./versions/versions.module": [
		"./src/app/versions/versions.module.ts",
		"common",
		"versions-versions-module"
	],
	"common/account/account.module": [
		"../../common/account/account.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;